/* Library */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { asyncConnect } from 'redux-connect';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import commonUtil from '../../../../../utils/commonUtil';
import * as AccountStatusDetailsAction from '../../actions';
import AccountPartialTransferWAP from './AccountPartialTransferWAP';
import AccountPartialTransferWEB from './AccountPartialTransferWEB';
import ApplyCSS from '../../../../../components/ApplyCSS';
import { getEventSummaryInfo } from '../../../../eventManagement/page/GiftList/actions';
import * as labelsActions from '../../../../../components/labels/actions';

const { getAccountPartialTransferDetails, getStatementDetailsForPrintAndDownload } = AccountStatusDetailsAction;
const { isLablesLoaded, loadLables } = labelsActions;
const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();

@asyncConnect([{
  promise: ({ store: { dispatch, getState } }) => {
    if (!isLablesLoaded(getState())) {
      return dispatch(loadLables());
    }
    return undefined;
  },
},
])
@connect(store => ({
  content: store.targetterContent.data,
  lables: store.labels.data,
  error: store.labels.error,
  loading: store.labels.loading,
  extraData: store.labels.extraData,
}),
  { labelsActions })

class AccountPartialTransferIndex extends Component {
  constructor(props) {
    super(props);
    this.eventId = (this.props.params && this.props.params.eventID) ? this.props.params.eventID : '';
    this.getStatementDetailsForPrintAndDownloadData = null;
    this.state = {
      statementPrintAndDownload: null,
    };
  }

  UNSAFE_componentWillMount() {
    this.props.getStatementDetailsForPrintAndDownload(this.eventId);
    if (!_.isEmpty(this.props.state.user.data) && !_.isEmpty(this.props.state.user.data.result)) {
      this.props.getEventSummaryInfo(this.eventId, this.props.state.user.data.result.profileId, this.props.state.user.data.result.emailId);
    }
  }

  componentDidMount() {
    commonUtil.addTransition();
  }

  getAccountPartialTransferDetailsFunction = () => {
    getAccountPartialTransferDetails(this.eventId)
      .then((res) => {
        if (res.body.status && res.body.status.status === 'success') {
          if (res.body && res.body.transferenceInfo && res.body.transferenceInfo.transferenceDetails) {
            const dataArr = res.body.transferenceInfo.transferenceDetails;
            if (dataArr) {
              /*eslint-disable*/
              _.each(dataArr, (a, idx) => {
                a.commission = + a.commission;
                a.amountTransferred = + a.amountTransferred;
              });
              /*eslint-enable*/
            }
            res.body.transferenceInfo.transferenceDetails = dataArr;
            if (this.accountPartialTransferWEB) {
              this.accountPartialTransferWEB.updateData(res.body);
            } else if (this.accountPartialTransferWAP) {
              this.accountPartialTransferWAP.updateData(res.body);
            }
          }
        }
      });
  }

  render() {
    return (
      <div>
        <ApplyCSS pageName="accountstatus" />
        {!_.isEmpty(this.props.lables) &&
          !_.isEmpty(this.props.eventInfo) ? <div>
            {channel === constChannels.WEB ?
              <AccountPartialTransferWEB
                ref={accountPartialTransferWEB => this.accountPartialTransferWEB = accountPartialTransferWEB}
                eventId={this.eventId}
                lables={this.props.lables}
                eventInfo={this.props.eventInfo}
                user={this.props.user}
                accountStatus={this.props.accountStatus}
                statementDetailsForPrintAndDownloadData={this.props.statementDetailsForPrintAndDownloadData}
                getAccountPartialTransferDetails={this.getAccountPartialTransferDetailsFunction}
                printingDate={this.props.printingDate}
              />
              :
              <AccountPartialTransferWAP
                ref={accountPartialTransferWAP => this.accountPartialTransferWAP = accountPartialTransferWAP}
                eventId={this.eventId}
                lables={this.props.lables}
                eventInfo={this.props.eventInfo}
                accountStatus={this.props.accountStatus}
                user={this.props.user}
                statementDetailsForPrintAndDownloadData={this.props.statementDetailsForPrintAndDownloadData}
                getAccountPartialTransferDetails={this.getAccountPartialTransferDetailsFunction}
                printingDate={this.props.printingDate}
              />
            }
          </div>
          : null}
      </div>
    );
  }
}
const mapStateToProps = state => ({
  state,
  user: state.user.data,
  lables: state.labels,
  accountStatus: state.accountSummary.accountStatus,
  eventInfo: state.accountSummary.eventInfo.eventInfo,
  statementDetailsForPrintAndDownloadData: state.accountSummary.statementDetailsForPrintAndDownloadData,
});

const matchDispatchToProps = dispatch => bindActionCreators({ getEventSummaryInfo, getStatementDetailsForPrintAndDownload }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(AccountPartialTransferIndex);

